import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import AssetBookingManagementTable from './AssetBookingManagementTable'
import {
  getReserveDocumentBooking,
  searchAssetBookingManagement,
} from '../../redux/actions/assetBookingManagement'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import { sessionRemoveItem, sessionSetItemObj } from '../../utils/sessionHelpers'
import { previewFile } from '../../utils/fileUtil'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function AssetBookingManagementOfficerWidgets(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.result || [])

  const history = useHistory()

  const onSearch = async (request, pagenumber = 1, pagesize = 5) => {
    console.log('onSearch', request)

    setIsLoading(true)
    startLoading()

    try {
      const response = await searchAssetBookingManagement(request, pagenumber, pagesize)
      console.log('response ', response)
      if (response.model) {
        setDataTable(response?.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('e => ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelecetAssetBooking = async (rowData) => {
    // console.log('handleSelecetAssetBooking ', rowData)

    if (rowData) {
      sessionSetItemObj('bookingInfo', rowData)
    } else {
      sessionRemoveItem('bookingInfo')
    }

    history.push({
      pathname: pathname.durableArticles.AssetBookingManagementDetailOfficer,
    })
  }

  const handleSearchAssetBooking = async (
    pagesize,
    pagenumber,
    reserveDocNo,
    project,
    reserveStartDate,
    reserveEndDate,
    reserveExpiredStartDate,
    reserveExpiredEndDate,
    reserveStatus
  ) => {
    const request = {
      reserveDocNo,
      project,
      reserveStartDate,
      reserveEndDate,
      reserveExpiredStartDate,
      reserveExpiredEndDate,
      reserveStatus,
    }

    onSearch(request, pagenumber, pagesize)
  }

  const handleGetReserveDoc = async (rowData) => {
    console.log('rowdata => ', rowData)
    setIsLoading(true)
    startLoading()
    try {
      var file = await getReserveDocumentBooking(rowData.id)

      previewFile(file, `แบบฟอร์มขอใช้งานครุภัณฑ์โครงการ_${rowData.id}`)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={' '} bordered>
        <AssetBookingManagementTable
          schema={dataTable}
          searchForm={formSchema.searchForm}
          loading={isLoading}
          onSelect={handleSelecetAssetBooking}
          onReload={handleSearchAssetBooking}
          onSearch={onSearch}
          disableAdd={true}
          onPreview={handleGetReserveDoc}
        />
      </Panel>
    </>
  )
}
